import { render, staticRenderFns } from "./CardSectionBrowsers.vue?vue&type=template&id=0749e3b0&"
import script from "./CardSectionBrowsers.vue?vue&type=script&lang=js&"
export * from "./CardSectionBrowsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports